import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../../core/services/account.service';

/**
 * Blocks firm-only areas (Team, Roles) for solo accountants — they have no team, so those screens
 * don't apply. Solo users are bounced to the dashboard instead of seeing an empty team page.
 */
export const firmGuard: CanActivateFn = () => {
  const account = inject(AccountService);
  const router = inject(Router);
  if (account.isFirm()) return true;
  router.navigate(['/app/dashboard']);
  return false;
};
